import { formatDistanceToNow, parseISO, type Locale } from "date-fns";
import { enUS, fr } from "date-fns/locale";
import i18next from "i18next";

import { AppLanguage, type AppLanguageType } from "@noa/i18n";

const APP_LANGUAGE_TO_DATEFNS_LOCALE = new Map<AppLanguageType, Locale>([
  [AppLanguage.fr, fr],
  [AppLanguage.en, enUS],
]);

export function formatRelativeTime(isoString?: string | null): string {
  if (!isoString) return "";

  const date = parseISO(isoString);
  const locale = APP_LANGUAGE_TO_DATEFNS_LOCALE.get(i18next.language as AppLanguageType) ?? fr;

  return formatDistanceToNow(date, { addSuffix: true, locale });
}

export function formatConversationDate(iso: string, locale: AppLanguageType): string {
  return new Intl.DateTimeFormat(locale, { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }).format(
    new Date(iso)
  );
}

export function formatLocaleDate(iso: string, locale: AppLanguageType): string {
  const [y, m, d] = iso.split("-").map(Number);

  return new Intl.DateTimeFormat(locale, { year: "numeric", month: "short", day: "numeric" }).format(
    new Date(y, m - 1, d)
  );
}
